import React, { useEffect, useState } from "react";
import SideMenu from "../../../components/Layout/menu/SideMenu";
import { Calendar } from "react-calendar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearState,
  feeData,
  getInterviewerSlots,
  getProgramWiseInterviewerList,
  postAddInterviewSlotReminder,
} from "../../../reducers/feeSlice";
import moment from "moment";
import PageLoader from "../../../components/UI/loader/PageLoader";
import ToastMessage from "../../../components/Toast/ToastComponent";

const AvailableSlotsDetails = () => {
  const {
    isFetching,
    programWiseInterviewerList,
    adminInterviewSlots,
    programAvailableSlots,
    isSuccess,
  } = useSelector(feeData);
  const [selectedDate, setSelectedDate] = useState();
  const [interviewerId, setInterviewerId] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const programMasterId = searchParams.get("programMasterId");
  const [showSuccessMessage, setEnableSuccessMessage] = useState(false);

  useEffect(() => {
    dispatch(getProgramWiseInterviewerList(programMasterId));
  }, []);

  useEffect(() => {
    if (interviewerId) {
      let obj = {
        date: moment(selectedDate).format("YYYY-MM-DD 00:00:00"),
        interviewerId: interviewerId,
      };

      dispatch(getInterviewerSlots(obj));
    }
  }, [selectedDate, interviewerId]);

  useEffect(() => {
    if (programWiseInterviewerList.length > 0) {
      setInterviewerId(programWiseInterviewerList[0]?.Admin?.id);
    }
  }, [programWiseInterviewerList]);

  const onClickAddSlotReminder = () => {
    let obj = {
      interviewerId: interviewerId,
    };

    dispatch(postAddInterviewSlotReminder(obj));

    console.log("printing data", obj);
  };

  useEffect(() => {
    if (isSuccess) {
      setEnableSuccessMessage(true);
      dispatch(clearState());
    }
  }, [isSuccess]);

  return (
    <>
      <SideMenu />
      <ToastMessage
        show={showSuccessMessage}
        setShow={() => setEnableSuccessMessage(false)}
        message={"Email Send Successfully"}
      />
      {isFetching && <PageLoader />}

      <div className="pageHeader">
        <div className="backBtn">
          {/* <img src="../assets/icons/back-btn.svg" alt="" /> */}
          {/* Back to Page */}
          {/* onClick={() => navigate(-1)} */}
        </div>
        <div className="pageTogglers">
          <div className="pageToggler active">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.91678 3.125C6.19089 3.125 4.79178 4.52411 4.79178 6.25C4.79178 7.97589 6.19089 9.375 7.91678 9.375C9.64267 9.375 11.0418 7.97589 11.0418 6.25C11.0418 4.52411 9.64267 3.125 7.91678 3.125ZM3.54178 6.25C3.54178 3.83375 5.50053 1.875 7.91678 1.875C10.333 1.875 12.2918 3.83375 12.2918 6.25C12.2918 8.66625 10.333 10.625 7.91678 10.625C5.50053 10.625 3.54178 8.66625 3.54178 6.25ZM12.7738 2.61165C12.9274 2.30254 13.3025 2.17649 13.6116 2.3301C15.0506 3.04525 16.0418 4.5313 16.0418 6.25C16.0418 7.9687 15.0506 9.45475 13.6116 10.1699C13.3025 10.3235 12.9274 10.1975 12.7738 9.88835C12.6201 9.57923 12.7462 9.20412 13.0553 9.0505C14.0858 8.5384 14.7918 7.47607 14.7918 6.25C14.7918 5.02393 14.0858 3.9616 13.0553 3.4495C12.7462 3.29588 12.6201 2.92077 12.7738 2.61165ZM7.91678 13.125C5.79794 13.125 3.88396 14.2802 2.65299 16.1284C2.49855 16.3603 2.41699 16.485 2.36864 16.5836C2.3336 16.6551 2.33612 16.6736 2.33676 16.6783C2.33679 16.6783 2.3377 16.6855 2.34228 16.7002C2.34771 16.7177 2.35637 16.7389 2.36831 16.7612C2.38025 16.7835 2.39311 16.8024 2.40461 16.8166C2.41253 16.8264 2.41785 16.8315 2.41954 16.833C2.42044 16.8335 2.42357 16.835 2.42994 16.8372C2.44529 16.8424 2.47754 16.8509 2.53957 16.8581C2.67638 16.874 2.86387 16.875 3.18541 16.875H12.6482C12.9697 16.875 13.1572 16.874 13.294 16.8581C13.356 16.8509 13.3883 16.8424 13.4036 16.8372C13.41 16.835 13.4131 16.8335 13.414 16.833C13.4157 16.8315 13.421 16.8264 13.429 16.8166C13.4405 16.8024 13.4533 16.7835 13.4653 16.7612C13.4772 16.7389 13.4859 16.7177 13.4913 16.7002C13.4959 16.6855 13.4968 16.6779 13.4968 16.6779C13.4974 16.6732 13.5 16.6551 13.4649 16.5836C13.4166 16.485 13.335 16.3603 13.1806 16.1284C11.9496 14.2802 10.0356 13.125 7.91678 13.125ZM1.61262 15.4355C3.03883 13.2941 5.31791 11.875 7.91678 11.875C10.5157 11.875 12.7947 13.2941 14.2209 15.4355C14.2266 15.444 14.2322 15.4524 14.2379 15.4609C14.3688 15.6574 14.4981 15.8515 14.5873 16.0333C14.6911 16.2451 14.761 16.4781 14.7445 16.754C14.7313 16.9735 14.6578 17.1821 14.5672 17.3512C14.4766 17.5204 14.3438 17.6972 14.1684 17.8298C13.9347 18.0066 13.6798 18.0717 13.4384 18.0997C13.2206 18.1251 12.9591 18.125 12.6787 18.125H3.15488C2.87446 18.125 2.61295 18.1251 2.39514 18.0997C2.15376 18.0717 1.89885 18.0066 1.66515 17.8298C1.4898 17.6972 1.35693 17.5204 1.26635 17.3512C1.17577 17.1821 1.10227 16.9735 1.0891 16.754C1.07253 16.4781 1.14246 16.2451 1.24628 16.0333C1.33544 15.8515 1.46479 15.6574 1.5957 15.4609L1.61262 15.4355ZM14.4416 12.9168C14.5966 12.6084 14.9722 12.484 15.2807 12.6389C16.6055 13.3044 17.7291 14.3659 18.5438 15.6784C18.5526 15.6925 18.5614 15.7067 18.5703 15.7209C18.6963 15.9227 18.8359 16.1464 18.882 16.4433C18.9344 16.7814 18.8429 17.1115 18.7006 17.3674C18.5582 17.6233 18.326 17.8751 18.0111 18.0089C17.7334 18.1269 17.432 18.126 17.1525 18.1251C17.1293 18.1251 17.1063 18.125 17.0834 18.125C16.7383 18.125 16.4584 17.8452 16.4584 17.5C16.4584 17.1548 16.7383 16.875 17.0834 16.875C17.2685 16.875 17.3723 16.8746 17.4501 16.8686C17.4849 16.8659 17.5039 16.8627 17.5136 16.8606C17.5182 16.8597 17.5206 16.859 17.5215 16.8587L17.5223 16.8584C17.5207 16.8591 17.5319 16.8544 17.5511 16.8359C17.5699 16.8176 17.5904 16.7916 17.6082 16.7597C17.6259 16.7279 17.6372 16.6967 17.6427 16.6711C17.648 16.6467 17.6467 16.6346 17.6467 16.6346C17.6456 16.6275 17.6439 16.6163 17.6264 16.5814C17.6012 16.5311 17.5624 16.4674 17.4818 16.3377C16.7781 15.204 15.8212 14.3093 14.7196 13.7559C14.4111 13.6009 14.2867 13.2253 14.4416 12.9168Z"
                fill="#0061BF"
              />
            </svg>
            Available Slot Details
          </div>
        </div>
        <div></div>
      </div>

      <div className="availableSlotContainer">
        <div className="availableSlotContainerHeader">
          <p className="heading">Available Slot Details</p>
          <div className="whiteTag">
            Total Slot: <span>{programAvailableSlots}</span>
          </div>
        </div>
        <div className="availableSlotContainerBody">
          <div className="availableSlotContainerLeft">
            {programWiseInterviewerList.length > 0 &&
              programWiseInterviewerList?.map((item, index) => {
                const { Admin } = item;

                return (
                  <div
                    onClick={() => {
                      setInterviewerId(Admin?.id);
                    }}
                    key={index}
                    className={`interviewer ${
                      interviewerId === Admin?.id ? "active" : ""
                    }`}
                  >
                    <p className="name">
                      {(Admin.firstName + " " + Admin.lastName)
                        .toLowerCase()
                        .split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.substring(1)
                        )
                        .join(" ")}
                    </p>
                    <img src="../assets/icons/blueArrowRight.svg" alt="" />
                  </div>
                );
              })}{" "}
          </div>
          <div className="availableSlotContainerCenter">
            <Calendar
              minDate={new Date()}
              onChange={setSelectedDate}
              value={selectedDate}
            />
          </div>
          <div className="availableSlotContainerRight">
            <p className="heading">Timing</p>
            {adminInterviewSlots?.length > 0
              ? adminInterviewSlots?.map((item) => {
                  const { time, id } = item;

                  return (
                    <div key={id} className="timeSlot">
                      <p>{time}</p>
                    </div>
                  );
                })
              : "No Slots"}
            <div className="footer">
              <button
                onClick={() => {
                  onClickAddSlotReminder();
                }}
                className="primary-outline-btn"
              >
                Send mail for add Slot
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AvailableSlotsDetails;
